<template>
  <div class="gx-ms">
    <button type="button" class="gx-ms__btn" @click="open = !open">
      <span v-if="value.length" class="gx-ms__summary">{{ summary }}</span>
      <span v-else class="gx-ms__placeholder">{{ placeholder }}</span>
<!--      <span class="gx-ms__caret">▾</span>-->
      <span class="gx-ms__caret">
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" :style="`flex-shrink: 0;transition: transform 0.22s cubic-bezier(0.4, 0, 0.2, 1);transform: rotate(${open?180:0}deg)`">
          <path d="M1 2.5l3 3 3-3" stroke="#4A4A6A" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
       </span>
    </button>
    <div v-if="open" class="gx-ms__panel" @click.stop>
      <input v-if="searchable" v-model.trim="keyword" class="gx-ms__search" placeholder="搜索" />
      <button v-if="selectAll" type="button" class="gx-ms__select-all" @click="toggleAll">{{ allFilteredSelected ? '取消全选' : '全选' }}</button>
      <label
        v-for="opt in filteredOptions"
        :key="opt.id"
        class="gx-ms__item"
        :class="{ 'gx-ms__item--on': value.includes(opt.id) }"
      >
        <input type="checkbox" :checked="value.includes(opt.id)" @change="toggle(opt.id, $event.target.checked)" />
        <span class="gx-ms__box">
          <svg v-if="value.includes(opt.id)" width="9" height="9" viewBox="0 0 8 8" fill="none"><path d="M1 4l2 2 4-4" stroke="#F4F6F8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg>
        </span>
        <span class="gx-ms__name">{{ opt.name || opt.dictionary_name }}</span>
      </label>
      <div v-if="!filteredOptions.length" class="gx-ms__empty">暂无选项</div>
      <div class="gx-ms__foot">
        <button type="button" class="gx-ms__op" @click="clear">清空</button>
        <button type="button" class="gx-ms__op gx-ms__op--primary" @click="open = false">完成</button>
      </div>
    </div>
    <div v-if="open" class="gx-ms__mask" @click="open = false"></div>
  </div>
</template>

<script>
export default {
  name: 'GxMultiSelect',
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '全部' },
    searchable: { type: Boolean, default: false },
    selectAll: { type: Boolean, default: false }
  },
  data() {
    return { open: false, keyword: '' }
  },
  computed: {
    filteredOptions() {
      const keyword = this.keyword.toLowerCase()
      return keyword ? this.options.filter((o) => String(o.name || o.dictionary_name || '').toLowerCase().includes(keyword)) : this.options
    },
    allFilteredSelected() {
      return this.filteredOptions.length > 0 && this.filteredOptions.every((o) => this.value.includes(o.id))
    },
    summary() {
      const names = this.options
        .filter((o) => this.value.includes(o.id))
        .map((o) => o.name || o.dictionary_name)
      const missing = this.value.filter((id) => !this.options.some((o) => o.id === id))
      return [...names, ...missing].join('、')
    }
  },
  methods: {
    toggle(id, checked) {
      const next = this.value.slice()
      const idx = next.indexOf(id)
      if (checked && idx === -1) next.push(id)
      if (!checked && idx > -1) next.splice(idx, 1)
      this.$emit('input', next)
    },
    clear() {
      this.$emit('input', [])
    },
    toggleAll() {
      const ids = this.filteredOptions.map((o) => o.id)
      const next = this.value.filter((id) => !ids.includes(id))
      this.$emit('input', this.allFilteredSelected ? next : [...next, ...ids])
    }
  }
}
</script>

<style scoped>
.gx-ms {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
.gx-ms__btn {
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid #e0e0ec;
  background: #FFFFFF;
  font-size: 12px;
  color: #1A1A2E;
  cursor: pointer;
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  min-width: 120px;
  max-width: 100%;
}
.gx-ms__summary {
  white-space: normal;
  word-break: break-all;
  line-height: 1.5;
  color: #1A1A2E;
}
.gx-ms__placeholder {
  color: #6A6A8A;
  line-height: 1.5;
}
.gx-ms__caret {
  color: #6A6A8A;
  font-size: 12px;
  margin-top: 3px;
  margin-left: auto;
  flex-shrink: 0;
}
.gx-ms__panel {
  position: absolute;
  top: 36px;
  left: 0;
  z-index: 30;
  min-width: 220px;
  max-width: 320px;
  max-height: 260px;
  overflow-y: auto;
  background: #FFFFFF;
  border: 1px solid #E1E5EE;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, .12);
  padding: 6px;
}
.gx-ms__search {
  width: 100%;
  height: 30px;
  box-sizing: border-box;
  margin-bottom: 6px;
  padding: 0 8px;
  border: 1px solid #e1e5ee;
  border-radius: 5px;
  outline: none;
}
.gx-ms__select-all {
  margin: 0 0 4px 8px;
  padding: 0;
  border: 0;
  color: #b58820;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
}
.gx-ms__item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #1A1A2E;
}
.gx-ms__item:hover {
  background: #F5F0E8;
}
.gx-ms__item--on {
  background: rgba(212, 169, 70, .08);
}
.gx-ms__item input[type='checkbox'] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gx-ms__box {
  width: 15px;
  height: 15px;
  border-radius: 4px;
  border: 1.5px solid rgba(212, 169, 70, .3);
  background: #FFFFFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all .15s;
}
.gx-ms__item--on .gx-ms__box {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border-color: transparent;
}
.gx-ms__name {
  flex: 1;
  min-width: 0;
}
.gx-ms__empty {
  padding: 16px;
  text-align: center;
  font-size: 12px;
  color: #6A6A8A;
}
.gx-ms__foot {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  padding-top: 6px;
  border-top: 1px solid #F0F0F5;
  margin-top: 4px;
  position: sticky;
  bottom: 0;
  background: #FFFFFF;
}
.gx-ms__op {
  height: 26px;
  padding: 0 12px;
  border-radius: 5px;
  border: 1px solid #E1E5EE;
  background: #FFFFFF;
  cursor: pointer;
  font-size: 12px;
  color: #4A4A6A;
}
.gx-ms__op--primary {
  background: linear-gradient(135deg, #D4A946, #E8C778);
  border-color: transparent;
  color: #F4F6F8;
  font-weight: 600;
}
.gx-ms__mask {
  position: fixed;
  inset: 0;
  z-index: 20;
}
</style>
